__turbopack_context__.v({
  "blok-big-title": "ProductCard-module__eC21cq__blok-big-title",
  "blok-subtitle": "ProductCard-module__eC21cq__blok-subtitle",
  "blok-title": "ProductCard-module__eC21cq__blok-title",
  "fade-in": "ProductCard-module__eC21cq__fade-in",
  "product-card": "ProductCard-module__eC21cq__product-card",
  "product-card__content": "ProductCard-module__eC21cq__product-card__content",
  "product-card__desc": "ProductCard-module__eC21cq__product-card__desc",
});
